/**
 * Generated by orval 🍺
 * Do not edit manually.
 * GTA CRM Demo API
 * GTA CRM 生产级 demo 的只读+轻写 API(feat-008;demo-scoped,零 model 零迁移)。
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `day_trip` - 1日游
 * * `custom_tour` - 定制游 3-15 天
 */
export type ProductFamilyEnum =
  (typeof ProductFamilyEnum)[keyof typeof ProductFamilyEnum];

export const ProductFamilyEnum = {
  day_trip: "day_trip",
  custom_tour: "custom_tour",
} as const;
